module.exports = __webpack_public_path__ + "img/check.8665c8be.svg";